// IO输入报警报表---IO输入报警汇总报表
const alarmIoSummery = (resolve) => {
  import('components/alarm/alarm.IoSummery').then((module) => {
    resolve(module)
  })
}

// IO输入报警报表---IO输入报警明细报表
const alarmIoDetail = (resolve) => {
  import('components/alarm/alarm.IoDetail').then((module) => {
    resolve(module)
  })
}
// 存储介质报警明细表(存储介质报表)
const reportsNavAlarmDiskerror = (resolve) => {
  import('components/alarm/alarm.reportsNavAlarmDiskerror').then((module) => {
    resolve(module)
  })
}

// 报警报表---报警汇总报表
const alarmAlarmSummery = (resolve) => {
  import('components/alarm/alarm.AlarmSummery').then((module) => {
    resolve(module)
  })
}

// 报警报表---报警报表
const alarmAlarmDetail = (resolve) => {
  import('components/alarm/alarm.AlarmDetail').then((module) => {
    resolve(module)
  })
}

// 停车报表-停车未熄火汇总表
const alarmParkingNSDSummery = (resolve) => {
  import('components/alarm/alarm.ParkingNSDSummery').then((module) => {
    resolve(module)
  })
}
// 停车报表-停车未熄火明细表
const alarmParkingNSDdetail = (resolve) => {
  import('components/alarm/alarm.ParkingNSDdetail').then((module) => {
    resolve(module)
  })
}
// 停车报表-超时停车汇总表
const alarmParkingOvertimeSummery = (resolve) => {
  import('components/alarm/alarm.ParkingOvertimeSummery').then((module) => {
    resolve(module)
  })
}
// 停车报表-超时停车明细表
const alarmParkingOvertimeDetail = (resolve) => {
  import('components/alarm/alarm.ParkingOvertimeDetail').then((module) => {
    resolve(module)
  })
}
// 停车报表-超时停车报警
const alarmParkingOvertimeAlarm = (resolve) => {
  import('components/alarm/alarm.ParkingOvertimeAlarm').then((module) => {
    resolve(module)
  })
}
// 平台电子围栏-围栏报警明细表
const alarmFenceDetail = (resolve) => {
  import('components/alarm/alarm.FenceDetail').then((module) => {
    resolve(module)
  })
}
// 平台电子围栏-围栏报警汇总表
const alarmFenceSummery = (resolve) => {
  import('components/alarm/alarm.FenceSummery').then((module) => {
    resolve(module)
  })
}
// 终端电子围栏-围栏报警明细表
const alarmDeviceFenceDetail = (resolve) => {
  import('components/alarm/alarm.DeviceFenceDetail').then((module) => {
    resolve(module)
  })
}
// 终端电子围栏-围栏报警汇总表
const alarmDeviceFenceSummery = (resolve) => {
  import('components/alarm/alarm.DeviceFenceSummery').then((module) => {
    resolve(module)
  })
}

// 上下线报表---上线率报表
const alarmOnline = (resolve) => {
  import('components/alarm/alarm.OnProbability').then((module) => {
    resolve(module)
  })
}
// 上下线报表---上下线汇总表
const alarmOnOffSummery = (resolve) => {
  import('components/alarm/alarm.OnOffSummery').then((module) => {
    resolve(module)
  })
}
// 上下线报表---上下线明细表
const alarmOnOffDetail = (resolve) => {
  import('components/alarm/alarm.OnOffDetail').then((module) => {
    resolve(module)
  })
}

// 未打表报警表
const notPlayingDetail = (resolve) => {
  import('components/alarm/alarm.NotPlaying').then((module) => {
    resolve(module)
  })
}

// ******************************* 旧版本报警 **************************
// 上下线报表---上线率报表
const reportsOnline = (resolve) => {
  import('components/reports/reports.onofflineRate').then((module) => {
    resolve(module)
  })
}

// 上下线报表---上下线汇总表
const reportsOnoffSummery = (resolve) => {
  import('components/reports/reports.onofflineSummery').then((module) => {
    resolve(module)
  })
}

// 上下线报表---上下线明细表
const reportsOnoffDetail = (resolve) => {
  import('components/reports/reports.onofflineDetail').then((module) => {
    resolve(module)
  })
}

// IO输入报警报表---IO输入报警汇总报表
const reportsIoSummery = (resolve) => {
  import('components/reports/reports.IoSummery').then((module) => {
    resolve(module)
  })
}

// IO输入报警报表---IO输入报警明细报表
const reportsIoDetail = (resolve) => {
  import('components/reports/reports.IoDetail').then((module) => {
    resolve(module)
  })
}

// 报警报表---报警汇总报表
const reportsAlarmSummery = (resolve) => {
  import('components/reports/reports.AlarmSummery').then((module) => {
    resolve(module)
  })
}

// 报警报表---乘客超员记录表
const reportsPassengerOvercrowding = (resolve) => {
  import('components/reports/reports.PassengerOvercrowding').then((module) => {
    resolve(module)
  })
}

// 报警报表---报警报表
const reportsAlarmDetail = (resolve) => {
  import('components/reports/reports.AlarmDetail').then((module) => {
    resolve(module)
  })
}
// 停车报表-停车未熄火汇总表
const reportsParkingNSDSummery = (resolve) => {
  import('components/reports/reports.ParkingNSDSummery').then((module) => {
    resolve(module)
  })
}
// 停车报表-停车未熄火明细表
const reportsParkingNSDdetail = (resolve) => {
  import('components/reports/reports.ParkingNSDdetail').then((module) => {
    resolve(module)
  })
}
// 停车报表-超时停车汇总表
const reportsParkingOvertimeSummery = (resolve) => {
  import('components/reports/reports.ParkingOvertimeSummery').then((module) => {
    resolve(module)
  })
}
// 停车报表-超时停车明细表
const reportsParkingOvertimeDetail = (resolve) => {
  import('components/reports/reports.ParkingOvertimeDetail').then((module) => {
    resolve(module)
  })
}

// 电子围栏-围栏报警明细表
const reportsFenceDetail = (resolve) => {
  import('components/reports/reports.FenceDetail').then((module) => {
    resolve(module)
  })
}
// 平台电子围栏-围栏报警明细表
const reportsOldFenceDetail1 = (resolve) => {
  import('components/reports/reports.FenceDetailOld').then((module) => {
    resolve(module)
  })
}
// 平台电子围栏-围栏报警汇总表
const reportsFenceSummery = (resolve) => {
  import('components/reports/reports.FenceSummery').then((module) => {
    resolve(module)
  })
}
// 终端电子围栏-围栏报警明细表
const reportsDeviceFenceDetail = (resolve) => {
  import('components/reports/reports.DeviceFenceDetail').then((module) => {
    resolve(module)
  })
}
// 终端电子围栏-围栏报警汇总表
const reportsDeviceFenceSummery = (resolve) => {
  import('components/reports/reports.DeviceFenceSummery').then((module) => {
    resolve(module)
  })
}
// 未打表报警
const notPlaying = (resolve) => {
  import('components/reports/reports.notPlaying.vue').then((module) => {
    resolve(module)
  })
}
// 信号干扰报警
const signalDisturbDatail = (resolve) => {
  import('components/reports/reports.signalDisturbDatail.vue').then((module) => {
    resolve(module)
  })
}
// 沉船报警
const wreckDatail = (resolve) => {
  import('components/reports/reports.wreckDatail.vue').then((module) => {
    resolve(module)
  })
}
// 防拆卸报警
const antiDisassemblyDatail = (resolve) => {
  import('components/reports/reports.antiDisassemblyDatail.vue').then((module) => {
    resolve(module)
  })
}
// 报警报表---硬件故障专题报表
const devFailure = (resolve) => {
  import('components/alarm/alarm.devFailure').then((module) => {
    resolve(module)
  })
}
// 报警报表---GPS轨迹异常报表
const gpsTrackFailure = (resolve) => {
  import('components/alarm/alarm.gpsTrackFailure').then((module) => {
    resolve(module)
  })
}
// 报警报表---轨迹分析漂点位置数据
const driftPoints = (resolve) => {
  import('components/alarm/alarm.driftPoints').then((module) => {
    resolve(module)
  })
}
// 客流统计---客流统计
const TrafficSummery = (resolve) => {
  import('components/alarm/alarm.TrafficSummery').then((module) => {
    resolve(module)
  })
}
// 油量报表---油量动态明细表
const OilDynamicDetail = (resolve) => {
  import('components/alarm/alarm.OilDynamicDetail').then((module) => {
    resolve(module)
  })
}
// 油量报表---油量异常明细表
const OilUnusualDetail = (resolve) => {
  import('components/alarm/alarm.OilUnusualDetail').then((module) => {
    resolve(module)
  })
}
// 油量报表---油量日报表明细表
const OilDaily = (resolve) => {
  import('components/alarm/alarm.OilDaily').then((module) => {
    resolve(module)
  })
}
// 海外司机刷卡---R海外司机刷卡明细表
const alarmDriverDetail = (resolve) => {
  import('components/reports/reports.driverDetail').then((module) => {
    resolve(module)
  })
}
const alarmRouter = {
  alarmPath: [{
    path: '/old/onofflinerate', // 上线率报表(上下线报表)
    component: reportsOnline
  },
  {
    path: '/old/reportsOnoffSummery', // 上下线汇总报表(上下线报表)
    component: reportsOnoffSummery
  },
  {
    path: '/old/reportsOnoffDetail', // 上下线明细报表(上下线报表)
    component: reportsOnoffDetail
  },
  {
    path: '/old/IoSummery', // IO输入报警汇总报表(IO输入报警报表)
    component: reportsIoSummery
  },
  {
    path: '/old/IoDetail', // IO输入报警明细报表(IO输入报警报表)
    component: reportsIoDetail
  },
  {
    path: '/old/AlarmSummery', // 报警汇总报表(报警报表)
    component: reportsAlarmSummery
  },
  {
    path: '/old/PassengerOvercrowding', // 报警汇总报表(乘客超员记录表)
    component: reportsPassengerOvercrowding
  },
  {
    path: '/old/AlarmDetail', // 报警报表(报警报表)
    component: reportsAlarmDetail
  },
  {
    path: '/old/ParkingNSDSummery', // 停车未熄火汇总表(停车报表)
    component: reportsParkingNSDSummery
  },
  {
    path: '/old/ParkingNSDdetail', // 停车未熄火明细表(停车报表)
    component: reportsParkingNSDdetail
  },
  {
    path: '/old/ParkingOvertimeSummery', // 超时停车汇总表(停车报表)
    component: reportsParkingOvertimeSummery
  },
  {
    path: '/old/ParkingOvertimeDetail', // 超时停车明细表(停车报表)
    component: reportsParkingOvertimeDetail
  },
  {
    path: '/old/FenceDetail', // 围栏报警明细表(电子围栏)
    component: reportsFenceDetail
  },
  {
    path: '/old/FenceDetail', // 平台围栏报警明细表(电子围栏)
    component: reportsOldFenceDetail1
  },
  {
    path: '/old/FenceSummery', // 平台围栏报警汇总表(电子围栏)
    component: reportsFenceSummery
  },
  {
    path: '/old/DeviceFenceDetail', // 终端围栏报警明细表(电子围栏)
    component: reportsDeviceFenceDetail
  },
  {
    path: '/old/DeviceFenceSummery', // 终端围栏报警汇总表(电子围栏)
    component: reportsDeviceFenceSummery
  },
  {
    path: '/old/notPlaying', // 未打表
    component: notPlaying
  },
  {
    path: '/old/signalDisturbDatail', // 信号干扰报警
    component: signalDisturbDatail
  },
  {
    path: '/old/wreckDatail', // 沉船报警
    component: wreckDatail
  },
  {
    path: '/old/antiDisassemblyDatail', // 防拆卸报警
    component: antiDisassemblyDatail
  },
  {
    path: '/old/NavAlarmDiskerror', // 防拆卸报警
    component: reportsNavAlarmDiskerror
  },
  {
    path: '/old/TrafficSummery', // 客流统计
    component: TrafficSummery
  },
  {
    path: '/old/OilUnusualDetail', // 油量异常明细表
    component: OilUnusualDetail
  },
  {
    path: '/old/OilDynamicDetail', // 油量动态明细表
    component: OilDynamicDetail
  },
  {
    path: '/old/OilDaily', // 油量日报表明细表
    component: OilDaily
  },
  {
    path: '/old/AlarmDriverDetail', // 海外司机刷卡细表
    component: alarmDriverDetail
  },
  {
    path: '/alarms/AlarmSummery', // 报警汇总报表(报警报表)
    component: alarmAlarmSummery
  },
  {
    path: '/alarms/AlarmDetail', // 报警报表(报警报表)
    component: alarmAlarmDetail
  },
  {
    path: '/alarms/IoSummery', // IO输入报警汇总报表(IO输入报警报表)
    component: alarmIoSummery
  },
  {
    path: '/alarms/IoDetail', // IO输入报警明细报表(IO输入报警报表)
    component: alarmIoDetail
  },
  {
    path: '/alarms/ParkingNSDSummery', // 停车未熄火汇总表(停车报表)
    component: alarmParkingNSDSummery
  },
  {
    path: '/alarms/ParkingNSDdetail', // 停车未熄火明细表(停车报表)
    component: alarmParkingNSDdetail
  },
  {
    path: '/alarms/ParkingOvertimeSummery', // 超时停车汇总表(停车报表)
    component: alarmParkingOvertimeSummery
  },
  {
    path: '/alarms/ParkingOvertimeDetail', // 超时停车明细表(停车报表)
    component: alarmParkingOvertimeDetail
  },
  {
    path: '/alarms/ParkingOvertimeAlarm', // 超时停车报警
    component: alarmParkingOvertimeAlarm
  },
  {
    path: '/alarms/FenceDetail', // 平台围栏报警明细表(电子围栏)
    component: alarmFenceDetail
  },
  {
    path: '/alarms/FenceSummery', // 平台围栏报警汇总表(电子围栏)
    component: alarmFenceSummery
  },
  {
    path: '/alarms/DeviceFenceDetail', // 终端围栏报警明细表(电子围栏)
    component: alarmDeviceFenceDetail
  },
  {
    path: '/alarms/DeviceFenceSummery', // 终端围栏报警汇总表(电子围栏)
    component: alarmDeviceFenceSummery
  },
  {
    path: '/alarms/OnProbability', // 上线率报表
    component: alarmOnline
  },
  {
    path: '/alarms/OnOffSummery', // 上下线汇总表
    component: alarmOnOffSummery
  },
  {
    path: '/alarms/OnoffDetail', // 上下线汇总表
    component: alarmOnOffDetail
  },
  {
    path: '/alarms/NotPlaying', // 上下线汇总表
    component: notPlayingDetail
  },
  {
    path: '/alarms/devFailure', // 硬件故障专题报表
    component: devFailure
  },
  {
    path: '/alarms/gpsTrackFailure', // GPS轨迹异常报表
    component: gpsTrackFailure
  },
  {
    path: '/alarms/driftPoints', // 轨迹分析漂点位置数据
    component: driftPoints
  }
  ]
}

export default alarmRouter



// WEBPACK FOOTER //
// ./src/router/alarm.js